import animateUnflippedElements from "./animateUnflippedElements";
import animateFlippedElements from "./animateFlippedElements";
import { getFlippedElementPositionsAfterUpdate } from "./getFlippedElementPositions";
import * as constants from "../constants";
import { assign } from "../utilities";

var createGetElementFunc = function createGetElementFunc(element, portalKey) {
  if (portalKey) {
    return function (id) {
      return document.querySelector("[" + constants.DATA_FLIP_ID + "=\"" + id + "\"][" + constants.DATA_PORTAL_KEY + "=" + portalKey + "]");
    };
  } else {
    return function (id) {
      return element.querySelector("[" + constants.DATA_FLIP_ID + "=\"" + id + "\"]");
    };
  }
};

var onFlipKeyUpdate = function onFlipKeyUpdate(_ref) {
  var _ref$cachedOrderedFli = _ref.cachedOrderedFlipIds,
      cachedOrderedFlipIds = _ref$cachedOrderedFli === undefined ? [] : _ref$cachedOrderedFli,
      _ref$inProgressAnimat = _ref.inProgressAnimations,
      inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat,
      _ref$cachedFlipChildr = _ref.cachedFlipChildrenPositions,
      cachedFlipChildrenPositions = _ref$cachedFlipChildr === undefined ? {} : _ref$cachedFlipChildr,
      _ref$flipCallbacks = _ref.flipCallbacks,
      flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks,
      containerEl = _ref.containerEl,
      applyTransformOrigin = _ref.applyTransformOrigin,
      spring = _ref.spring,
      debug = _ref.debug,
      portalKey = _ref.portalKey,
      _ref$staggerConfig = _ref.staggerConfig,
      staggerConfig = _ref$staggerConfig === undefined ? {} : _ref$staggerConfig,
      _ref$decisionData = _ref.decisionData,
      decisionData = _ref$decisionData === undefined ? {} : _ref$decisionData;
  var newFlipChildrenPositions = getFlippedElementPositionsAfterUpdate({
    element: containerEl,
    portalKey: portalKey
  });
  var getElement = createGetElementFunc(containerEl, portalKey);

  var isFlipped = function isFlipped(id) {
    return cachedFlipChildrenPositions[id] && newFlipChildrenPositions[id];
  };

  var unflippedIds = Object.keys(cachedFlipChildrenPositions).concat(Object.keys(newFlipChildrenPositions)).filter(function (id) {
    return !isFlipped(id);
  });
  var baseArgs = {
    flipCallbacks: flipCallbacks,
    getElement: getElement,
    cachedFlipChildrenPositions: cachedFlipChildrenPositions,
    newFlipChildrenPositions: newFlipChildrenPositions,
    inProgressAnimations: inProgressAnimations
  };
  animateUnflippedElements(assign({}, baseArgs, {
    unflippedIds: unflippedIds
  }));
  var flippedIds = cachedOrderedFlipIds.filter(isFlipped);
  var readyToBeFlippedIds = flippedIds.filter(function (id) {
    return newFlipChildrenPositions[id] !== "unloadedImg";
  });
  var animateFlippedElementsArgs = assign({}, baseArgs, {
    flippedIds: readyToBeFlippedIds,
    applyTransformOrigin: applyTransformOrigin,
    spring: spring,
    debug: debug,
    staggerConfig: staggerConfig,
    decisionData: decisionData
  });
  animateFlippedElements(animateFlippedElementsArgs);
  var waitATickIds = flippedIds.filter(function (id) {
    return newFlipChildrenPositions[id] === "unloadedImg";
  });

  if (waitATickIds.length) {
    setTimeout(function () {
      // we'll re-measure size in the DOM, hopefully the image is rendered by now
      var newFlipChildrenPositions = getFlippedElementPositionsAfterUpdate({
        element: containerEl,
        portalKey: portalKey,
        ids: waitATickIds
      });
      var loadedImgIds = waitATickIds.filter(function (id) {
        return newFlipChildrenPositions[id] !== "unloadedImg";
      });
      animateFlippedElements(assign({}, animateFlippedElementsArgs, {
        flippedIds: loadedImgIds
      }));
    });
  }
};

export default onFlipKeyUpdate;